import clsx from "clsx";
import React from "react";
import { Heading } from "web/react/emo/heading";
import { usePopularDesignerPills } from "web/react/hooks/use-popular-pills/use-popular-designer-pills";
import { UniversalFiltersData } from "web/types/universal-filters";
import { CurvedPill } from "./curved-pill";
import * as styles from "./suggested-pills.css";

interface SuggestedPillsProps {
    filters: UniversalFiltersData;
}

export function SuggestedPills({ filters }: SuggestedPillsProps): React.ReactElement | null {
    const { pills, designer, onPillClick, isLoading } = usePopularDesignerPills(filters);

    if (!pills || pills.length < 2 || !designer) {
        return null;
    }

    return (
        <div className={styles.container}>
            <Heading as="h3" textStyle={"title-2"} className={styles.heading}>
                {/* TODO: i18n */}
                {"Discover more in"} {designer?.label}
            </Heading>

            <div className={clsx(styles.pills, { [styles.loading]: isLoading })}>
                {pills?.slice(0, 6).map((pill) => (
                    <CurvedPill
                        key={pill.id}
                        label={pill.label}
                        onClick={() => onPillClick(pill)}
                        active={pill.checked}
                        activeHighlighted={pill.checked}
                        disabled={pill.disabled}
                    />
                ))}
            </div>
        </div>
    );
}
